
    import '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/introduc.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/introduc.md?type=demo')
};